export default function React_Intro() {
  return (
    <div>
      <h1>React_Intro Component</h1>
      <p>This is the React_Intro tutorial page.</p>
    </div>
  );
}
